module.exports = __webpack_public_path__ + "static/caitlin_s-4d3b5352410439324aa2be37d1ea69b1.png";